import {Component, Input} from '@angular/core';
import {DescriptionCardInfoComponent} from '../../shared/card-view/description-card-info/description-card-info.component';
import {DescriptionCardImageModel, DescriptionCardInfo} from '../../shared/card-view/description-card-info/description-card-info';
import {OrderModel} from '../../dashboard/monitoring/order.model';
import {RouteLibraryService} from '../../route/route-library.service';
import {TranslateService} from '@ngx-translate/core';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';
import {MainLightboxService} from '../../layout/main-lightbox.service';
import {UnitImagesShort} from '../../dashboard/monitoring/unit';
import {HttpClient} from '@angular/common/http';
import {OrderPhotosLightboxService} from '../../layout/order-photos-lightbox/order-photos-lightbox.service';
import {timestampToTime} from '../../utility/timestamp-functions';
import {RouteLibraryEntities} from '../../route/route-library-entity';
import {UserLinkService} from '../../user/user-link.service';
import {AuthorizationService} from '../../authorization/authorization.service';

@Component({
  selector: 'app-unit-last-order-info',
  templateUrl: '../../shared/card-view/description-card-info/description-card-info.component.html',
  styleUrls: ['../../shared/card-view/description-card-info/description-card-info.component.scss']
})
export class UnitLastOrderInfoComponent extends DescriptionCardInfoComponent {
  info: DescriptionCardInfo;
  @Input() imageSrc: DescriptionCardImageModel;
  @Input() imagesShort: Array<UnitImagesShort>;

  @Input() set model(model: OrderModel) {
    this.info = {
      columnFirst: [
        {
          title: 'Name and Surname',
          iconName: 'ic_profile',
          value: () => {
            return this.getValidValue(model.end_user_full_name);
          }
        },
        {
          title: 'Login',
          iconName: 'ic_phone',
          routerLink: this.routeLibrary.getRoute({
            entity: RouteLibraryEntities.END_USER,
            id: model.end_user_id, action: 'view'
          }),
          value: () => {
            return model.end_user_login;
          }
        },
        {
          title: 'Rate',
          iconName: 'ic_dollar',
          routerLink: this.getValidValue(model.end_user_price_plan_id)
            ? this.routeLibrary.getRoute({
              entity: RouteLibraryEntities.END_USER_PRICE_PLAN,
              id: model.end_user_price_plan_id, action: 'view'
            }) : null,
          value: () => {
            return this.getValidValue(model.end_user_price_plan_id)
              ? this.getValidValue(model.endUserPricePlanTranslatedName) : '';
          }
        },
        {
          title: 'Payment method',
          iconName: 'ic_wallet',
          value: () => {
            return this.paymentMethod(model.paymentMethods);
          }
        },
        {
          title: 'Order cost',
          iconName: 'ic_cash',
          value: () => {
            return this.getValidValue(model.total_price) ? model.total_price + ' ' + model.currency_code : '';
          }
        },
      ],
      columnSecond: [
        this.startTime(model.start_time),
        this.finishTime(model.finish_time),
        {
          title: 'Duration',
          iconName: 'iс_duration',
          value: () => {
            return this.getValidValue(model.finish_time) && this.getValidValue(model.start_time)
              ? timestampToTime(model.finish_time - model.start_time) : '';
          }
        },
        this.distance(model.mileage),
        {
          title: 'Debt',
          iconName: 'ic_debt',
          value: () => {
            return this.getValidValue(model.debt) && model.debt > 0
              ? model.debt + ' ' + model.currency_code : '';
          }
        },
      ]
    };
  }

  constructor(
    protected routeLibrary: RouteLibraryService,
    protected translates: TranslateService,
    protected immutableListRepositoryService: ImmutableListRepositoryService,
    protected mainLightboxService: MainLightboxService,
    protected http: HttpClient,
    protected orderPhotosLightboxService: OrderPhotosLightboxService,
    protected userLinkService: UserLinkService,
    protected authorizationService: AuthorizationService
  ) {
    super(
      immutableListRepositoryService,
      mainLightboxService,
      http,
      orderPhotosLightboxService,
      translates,
      routeLibrary,
      userLinkService,
      authorizationService
    );
  }
}
